import { render, staticRenderFns } from "./TextExpandable.vue?vue&type=template&id=5a434411"
import script from "./TextExpandable.vue?vue&type=script&lang=js"
export * from "./TextExpandable.vue?vue&type=script&lang=js"
import style0 from "./TextExpandable.vue?vue&type=style&index=0&id=5a434411&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports